const ACTIVE_STATE_ALERT_SESSION_KEY = 'shareableLinks.activeStateAlertDismissedForShowInactive';

export function shouldShowActiveStateAlert(showInactive: boolean) {
  return sessionStorage.getItem(ACTIVE_STATE_ALERT_SESSION_KEY) !== JSON.stringify(showInactive);
}

export function dismissActiveStateAlert(showInactive: boolean) {
  sessionStorage.setItem(ACTIVE_STATE_ALERT_SESSION_KEY, JSON.stringify(showInactive));
}

export function clearActiveStateAlertSession() {
  sessionStorage.removeItem(ACTIVE_STATE_ALERT_SESSION_KEY);
}
